import React, { MouseEventHandler } from 'react';
import { Button } from 'flowbite-react';

import LineBreakParagraphs from '@/components/commons/page-elements/LineBreakParagraph';

import BioHelpLink from './BioHelpLink';
import bioStyles from './Bio.module.css';

interface Props {
    readonly header: string;
    readonly body: string;
    readonly isSelected: boolean;
    readonly onClick: MouseEventHandler;
    readonly onReject: MouseEventHandler;
}

function StarterBioCard({
    header,
    body,
    isSelected,
    onClick,
    onReject,
}: Props) {
    return (
        <article className={`p-8 min-w-1/3 grow rounded-lg max-w-full border ${isSelected ? 'border-progressBarBlue' : 'border-gray-200'} bg-cirrusWhite shadow-md sm:min-h-[490px] flex flex-col gap-4 justify-between`}>
            <div className="flex flex-col justify-between gap-8 sm:gap-0">
                <div className="flex flex-col gap-4 overflow-hidden">
                    <h1 className="text-center font-instrument text-[24px] font-semibold leading-24 text-cleanSlate">{header}</h1>
                    <div className={`${bioStyles.clipText}`}>
                        <LineBreakParagraphs
                            text={body}
                            externalStyles="text-base text-cleanSlate leading-6"
                            hideParagraphPadding
                        />
                    </div>
                </div>
                {!isSelected && <Button className="bg-cleanSlate my-4" onClick={onClick}>Select this bio</Button>}

            </div>
            <div className="flex justify-center">
                <BioHelpLink onClick={onReject} />
            </div>
        </article>
    );
}

export default StarterBioCard;
